import { render } from "./right-sidebar.vue?vue&type=template&id=c878df9a&scoped=true&ts=true"
import script from "./right-sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./right-sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./right-sidebar.vue?vue&type=style&index=0&id=c878df9a&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c878df9a"],['__file',"src/views/browse-view/components/right-sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c878df9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c878df9a', __exports__)) {
    console.log('reload')
    api.reload('c878df9a', __exports__)
  }
  
  module.hot.accept("./right-sidebar.vue?vue&type=template&id=c878df9a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('c878df9a', render)
  })

}


export default __exports__